import format from 'date-fns/format'; // https://date-fns.org/docs/format
import localeES from 'date-fns/locale/es';
import parseISO from 'date-fns/parseISO';
import capitalize from 'lodash/capitalize';

/**
 * Filtro para formatear Fecha usando date-fns y locale ES
 */
export function FormatFecha(fecha, formato) {
  return formatFecha(fecha, formato);
}

// Función de date-fns, usando locale es. Si formato no se define, usa el default
export function formatFecha(date: Date | string | number, formato?: string, capitalizar?: boolean) {
  if (!date) return '';
  if (!formato) formato = 'YYYY-MM-DD';

  if (typeof date === 'string') {
    date = parseISO(date);
  }

  let formatted = format(date, formato, { locale: localeES });

  if (capitalizar)
    formatted = capitalize(formatted);


  return formatted;
}

/**
 * Filtro para formatear numero decimal con 2 centavos
 */
export function FormatMontoCentavos(value) {
  if (isNaN(value)) return '';

  if (typeof value == 'string')
    value = parseFloat(value);

  // 2 numeros decimales
  let monto = value.toFixed(2);

  // Separo parte entera y fraccionaria
  let partes = monto.split('.'),
    entero = partes[0],
    fraccion = partes[1];

  let regex = /(\d+)(\d{3})/;

  // Agrego separadores de mil (punto)
  while (regex.test(entero)) {
    entero = entero.replace(regex, '$1' + '.' + '$2');
  }

  // Retorno ambas partes, usando coma antes de la parte fraccionaria
  return entero + ',' + fraccion;
}

/**
 * Filtro para formatear numero decimal sin centavos
 */
export function FormatMonto(value) {
  if (isNaN(value)) return '';

  if (typeof value == 'string')
    value = parseFloat(value);

  // sin numeros decimales
  let monto = value.toFixed(0);

  // Separo parte entera y fraccionaria
  let regex = /(\d+)(\d{3})/;

  // Agrego separadores de mil (punto)
  while (regex.test(monto)) {
    monto = monto.replace(regex, '$1' + '.' + '$2');
  }

  // Retorno entero
  return monto;
}